export default {
    hello: "Hola",
    create_a_project: "Crea un curso",
    customize_your_academy: "Personalización",
    check_your_sales: "Consulta tus ingresos",
    create_your_project: "Crea tu curso",
    placeholder_name: "Mi curso en Brainspro",
    text_describe: "El título describe en una sola frase lo que sus alumnos aprenderán.",
    bttn_close: "Cerrar",
    bttn_create: "¡Crear curso!",
    contacts: '¿Más dudas?, ¡Contáctanos!',
    client_attention: 'Atención al cliente: ',
    mail_client_attention: "hola{'@'}brainspro.com",
    support: 'Soporte técnico: ',
    email_support: "soporte{'@'}brainspro.com",
    phone_whatsapp: 'Teléfono y Whatsapp: ',
    phone_number: '+34 626 201 897',
    text_support: 'Reserva una cita online con uno de nuestros expertos',
    href_intercom: 'Ir a la base de conocimiento',
    href_custom_domain: 'Más sobre la configuración de dominios personalizados.',
    no_annual_data: "No hay datos anuales",
    no_monthly_data: "No hay datos mensuales",
    no_sales_yet: "(sin ventas aún)",
    // TEMPORAL: "Crea tu primer curso" en vez de "...producto", hasta que se implementen
    // los tipos de producto — revertir o ajustar cuando eso ocurra (mismo criterio que
    // general.products_temp en lang/es/general.js). Solo se usa en DashboardHelper.vue.
    create_first_product: "Crea tu primer curso →",

    checklist_title: "Completa la configuración de tu academia",
    checklist_complete: "Configuración completa",
    checklist_subdomain: "Configura tu subdominio",
    checklist_logo: "Sube el logo de tu academia",
    checklist_brand: "Añade el nombre y eslogan de tu academia",
    checklist_contact: "Completa tus datos de contacto",
    checklist_product: "Crea tu primer curso",

    kb_chatbot_title: "¿Qué necesitas para tu academia?",
    kb_chatbot_placeholder: "Pregúntame cómo gestionar tu academia...",
    kb_chatbot_welcome: "¡Hola! Estoy aquí para ayudarte a gestionar y hacer crecer tu academia. Elige una sugerencia o escríbeme tu pregunta.",
    kb_chatbot_send: "Enviar",
    kb_chatbot_suggestions: [
        "¿Cómo matriculo a mis alumnos?",
        "¿Cómo personalizo mi academia?",
        "¿Cómo puedo vender más cursos?",
    ],
    kb_chatbot_loading: "Buscando la respuesta...",
    kb_chatbot_unanswered: "En este punto quizás lo mejor es que contactes con una persona de nuestro equipo para resolver tus dudas.",
    kb_chatbot_retry: "Ha habido un problema técnico. Puedes intentarlo de nuevo.",
    kb_chatbot_retry_button: "Inténtalo de nuevo",
    kb_chatbot_error: "Ha ocurrido un error. Inténtalo de nuevo en unos minutos.",
    kb_chatbot_open_ticket: "Contactar con soporte",
    kb_chatbot_ticket_subject: "Consulta desde el asistente de la base de conocimiento",
}
